import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { Filters, Parameters } from '../../models';
import { BaseItemListingQuery } from '../common/base-item-listing-query.class';
import { ElementType } from '../../elements';
export var ItemsFeedQuery =
/*#__PURE__*/
function (_BaseItemListingQuery) {
  _inherits(ItemsFeedQuery, _BaseItemListingQuery);

  function ItemsFeedQuery(config, queryService) {
    var _this;

    _classCallCheck(this, ItemsFeedQuery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ItemsFeedQuery).call(this, config, queryService));
    _this.config = config;
    _this.queryService = queryService;
    _this._queryConfig = {};
    return _this;
  }
  /**
   * Gets only item of given type
   * @param type Codename of type to get
   */


  _createClass(ItemsFeedQuery, [{
    key: "type",
    value: function type(_type) {
      this.parameters.push(new Filters.TypeFilter(_type));
      return this;
    }
    /**
     * Gets items of given types (logical or)
     * I.e. get items of either 'Actor' or 'Movie' type
     * @param types Types to get
     */

  }, {
    key: "types",
    value: function types(_types) {
      this.parameters.push(new Filters.TypeFilter(_types));
      return this;
    }
    /**
     * Gets only item from given collection
     * @param collection Codename of collection to get
     */

  }, {
    key: "collection",
    value: function collection(_collection) {
      this.parameters.push(new Filters.CollectionFilter(_collection));
      return this;
    }
    /**
     * Gets items from given collections (logical or)
     * I.e. get items of either 'default' or 'christmas-campaign' collection
     * @param collections Collections to get
     */

  }, {
    key: "collections",
    value: function collections(_collections) {
      this.parameters.push(new Filters.CollectionFilter(_collections));
      return this;
    }
    /**
     * Language codename
     * @param languageCodename Codename of the language
     */

  }, {
    key: "languageParameter",
    value: function languageParameter(languageCodename) {
      this.parameters.push(new Parameters.LanguageParameter(languageCodename));
      return this;
    }
    /**
     * Used to limit the number of elements returned by query.
     * @param elementCodenames Array of element codenames to fetch
     */

  }, {
    key: "elementsParameter",
    value: function elementsParameter(elementCodenames) {
      this.parameters.push(new Parameters.ElementsParameter(elementCodenames));
      return this;
    }
  }, {
    key: "toPromise",
    value: function toPromise() {
      var _a;

      return this.queryService.getItemsFeed(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var action = '/items-feed'; // add default language is necessary

      this.processDefaultLanguageParameter();
      return _get(_getPrototypeOf(ItemsFeedQuery.prototype), "resolveUrlInternal", this).call(this, action);
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */

  }, {
    key: "queryConfig",
    value: function queryConfig(_queryConfig) {
      this._queryConfig = _queryConfig;
      return this;
    }
  }, {
    key: "map",
    value: function map(json) {
      return this.queryService.mappingService.itemsFeedResponse(json);
    }
  }, {
    key: "allResponseFactory",
    value: function allResponseFactory(items, responses) {
      if (this.canLinkItems()) {
        this.linkItems(items, responses);
      }

      return {
        items: items,
        responses: responses
      };
    }
  }, {
    key: "linkItems",
    value: function linkItems(items, responses) {
      // prepare all available items (including components) for linking
      var allContentItems = []; // process linked items (modular_content part of the response)

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = responses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var response = _step.value;
          allContentItems.push.apply(allContentItems, _toConsumableArray(Object.values(response.data.linkedItems)));
        } // add standard items

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop = function _loop() {
          var item = _step2.value;

          if (!allContentItems.find(function (m) {
            return m.system.codename.toLowerCase() === item.system.codename.toLowerCase();
          })) {
            allContentItems.push(item);
          }
        };

        for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop();
        } // process main items

      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      for (var _i = 0, _allContentItems = allContentItems; _i < _allContentItems.length; _i++) {
        var item = _allContentItems[_i];

        for (var _i2 = 0, _Object$keys = Object.keys(item.elements); _i2 < _Object$keys.length; _i2++) {
          var elementKey = _Object$keys[_i2];
          var element = item.elements[elementKey];

          if (element.type === ElementType.ModularContent) {
            var linkedItemElement = element;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              var _loop2 = function _loop2() {
                var linkedItemCodename = _step3.value;

                if (!linkedItemElement.linkedItems.find(function (m) {
                  return m.system.codename.toLowerCase() === linkedItemCodename.toLowerCase();
                })) {
                  var linkedItem = allContentItems.find(function (m) {
                    return m.system.codename.toLowerCase() === linkedItemCodename.toLowerCase();
                  });

                  if (linkedItem) {
                    linkedItemElement.linkedItems.push(linkedItem);
                  }
                }
              };

              for (var _iterator3 = linkedItemElement.value[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                _loop2();
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                  _iterator3["return"]();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }

          if (element.type === ElementType.RichText) {
            var richTextElement = element;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              var _loop3 = function _loop3() {
                var linkedItemCodename = _step4.value;

                if (!richTextElement.linkedItems.find(function (m) {
                  return m.system.codename.toLowerCase() === linkedItemCodename.toLowerCase();
                })) {
                  var linkedItem = allContentItems.find(function (m) {
                    return m.system.codename.toLowerCase() === linkedItemCodename.toLowerCase();
                  });

                  if (linkedItem) {
                    richTextElement.linkedItems.push(linkedItem);
                  }
                }
              };

              for (var _iterator4 = richTextElement.linkedItemCodenames[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                _loop3();
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                  _iterator4["return"]();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: "canLinkItems",
    value: function canLinkItems() {
      if (this.config.linkedItemsReferenceHandler === 'ignore') {
        return false;
      }

      if (this._queryConfig.disableItemLinking === true) {
        return false;
      }

      return true;
    }
  }]);

  return ItemsFeedQuery;
}(BaseItemListingQuery);